interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "CAD";
};

const CAD: Currency = Object.freeze({
  "displayName": "Canadian Dollar",
  "numericCode": 124,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "CAD",
  "symbol": "$"
});

export { CAD };
